import { render } from "./WhatsappTemplateCallToAction.vue?vue&type=template&id=97d2c33e&scoped=true&ts=true"
import script from "./WhatsappTemplateCallToAction.vue?vue&type=script&lang=ts"
export * from "./WhatsappTemplateCallToAction.vue?vue&type=script&lang=ts"

import "./WhatsappTemplateCallToAction.vue?vue&type=style&index=0&id=97d2c33e&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d2c33e"]])

export default __exports__